import { array, boolean, nullable, string, struct, UnknownRecord } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { StructuredIds as AncillaryItemStructuredIds } from '../../../../../job/ancillary-item/StructuredIds';
import { Id as JobId } from '../../../../../job/Id';
import { Id as RequirementId } from '../../../../../job/requirement/Id';
import { StructuredIds as SubAncillaryItemStructuredIds } from '../../../../../job/sub-ancillary-item/StructuredIds';

export const Request = struct({
	transaction: struct({
		jobId: JobId,

		//
		// from the 'details' step
		//

		transactionName: string,
		transactionRef: nullable(string),

		targetAt: nullable(string),

		//
		// from the 'requirements' step
		//

		requirements: array(RequirementId),

		ancillaryItems: iotsUtils.withDefault(AncillaryItemStructuredIds, {}),

		subAncillaryItems: iotsUtils.withDefault(SubAncillaryItemStructuredIds, {}),

		notes: nullable(string),

		customFormData: nullable(UnknownRecord),

		iCommandITWJobSync: boolean,
	}),
});
